/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum Role {
  ClientUser = "ClientUser",
  EnvoyAdmin = "EnvoyAdmin",
  EnvoySales = "EnvoySales",
  EnvoyUser = "EnvoyUser",
  LPUser = "LPUser",
}

export const RoleDisplay: Record<Role, string> = {
  [Role.ClientUser]: "ClientUser",
  [Role.EnvoyAdmin]: "EnvoyAdmin",
  [Role.EnvoySales]: "EnvoySales",
  [Role.EnvoyUser]: "EnvoyUser",
  [Role.LPUser]: "LPUser",
};
